<p-toast [preventDuplicates]="true" [preventOpenDuplicates]="true"/>
<p-divider/>
<div class="" *ngFor="let prj of proyectoAsignado">
    <div class="card h-full">
        <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-4">
            <div class="flex flex-column text-center md:text-left">
                <span class="text-700 text-2xl mb-2 font-bold">Proyecto: {{ proyectoAsignado[0].nombre }}</span>
                <span class="text-700 text-lg">{{ proyectoAsignado[0].descripcion }}</span>
            </div>
            <div class="p-toolbar-group-end">
                        <span class="p-2">
                               <p-button
                                   (click)="goBack()"
                                   label="Regresar"
                                   icon="pi pi-undo text-2xl"
                                   styleClass="p-button-rounded ml-2"/>
                        </span>
            </div>
        </div>
        <p-tabView>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="pi pi-book"></i>
                    <span class="pl-1">Generales</span>
                </ng-template>
                <app-generales-proyecto [rendertitle]="true" [prj]="prj"
                ></app-generales-proyecto>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
<p-divider/>
<shared-loader class="global-overlay" [hidden]="!_showLoader"></shared-loader>
<p-card *ngIf="this.selected!==null"
        [header]="!esConstruccion()?this.selected.nombreTramite  + ' - URBANIZACION':this.selected.nombreTramite ">
    <div>
        <p-panel [collapsed]="false" header="Recepción de obra" [toggleable]="true">
            <div class="p-fluid p-formgrid grid mt-2">
                <div class="field col-12 md:col-3">
                    <span class="p-float-label">
                        <input [(ngModel)]="this.tramiteService.areaTotalSignal" id="areaTotal" type="number"
                               #areaTotalInput="ngModel"
                               required pInputText
                               pattern="(0(\.0+)?|[1-9][0-9]*(\.[0-9]+)?)"
                               [min]="0"
                               [ngClass]="{'ng-invalid ng-dirty' : (this.tramiteService.areaTotalSignal()==null||this.tramiteService.areaTotalSignal()==0)}"
                               disabled="disabled"/>
                        <label for="areaTotal" class="mb-2">Área total <small style="color:black"><b> m²</b></small>
                            <small style="color:red"><b> *</b></small></label>
                    </span>
                </div>
            </div>
            <ng-container>
                <div class="text-900 font-semibold text-xl">Avance de la obra</div>
                <div class="p-fluid p-formgrid grid mt-2">
                    <div class="field col-12 md:col-3">
                        <p-dropdown [(ngModel)]="etapaRecepcionSeleccionada" #nivelDrop [options]="etapaRecepcion"
                                    optionLabel="descripcion" [showClear]="true" (onChange)="limpiarPorcentajes()"
                                    placeholder="Seleccione Etapa de recepción *"
                                    [required]="true"
                                    [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !etapaRecepcionSeleccionada}"></p-dropdown>
                        <small style="color:red" class="ng-dirty ng-invalid"
                               *ngIf="!tramiteCompleto && !etapaRecepcionSeleccionada">
                            <b>Favor seleccionar un etapa de recepción</b>
                        </small>
                    </div>
                    <div class="field col-12 md:col-4"
                         *ngIf="etapaRecepcionSeleccionada!=null&&etapaRecepcionSeleccionada.id=='1'&&!esConstruccion()">
                        <span class="p-float-label">
                            <input [(ngModel)]="porcentajeParcelacion" id="parcelacion" type="number" [min]="0"
                                   [max]="100" (input)="onInputChange($event)"
                                   placeholder="Avance %" (keydown)="isNumericValid($event)" #parcelacionInput required
                                   pInputText
                                   [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && (porcentajeParcelacion==0 || porcentajeParcelacion==null)}"/>
                            <label for="parcelacion" class="mb-2">Parcelacion
                                <small style="color:red"><b> *</b></small></label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4"
                         *ngIf="etapaRecepcionSeleccionada!=null&&etapaRecepcionSeleccionada.id=='1'&&esConstruccion()">
                        <span class="p-float-label">
                            <input [(ngModel)]="porcentajeConstruccion" id="construccion" type="number" [min]="0"
                                   [max]="100" (input)="onInputChange($event)"
                                   placeholder="Avance %" (keydown)="isNumericValid($event)" #construccionInput required
                                   pInputText
                                   [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && (porcentajeConstruccion==0 || porcentajeConstruccion==null)}"/>
                            <label for="construccion" class="mb-2">Construcción
                                <small style="color:red"><b> *</b></small></label>
                        </span>
                    </div>
                </div>
            </ng-container>
        </p-panel>
        <p-divider/>
        <div class="mt-1">
            <p-accordion [activeIndex]="activeAccordionIndex" [multiple]="true">
                <p-accordionTab header="Detalles de obras realizadas" class="line-height-3 m-0">
                    <ng-container *ngIf="!esConstruccion(); else recepcionElse">
                        <div>
                            <p-table styleClass="p-datatable-gridlines" [value]="obrasRealizadasUrbanizacion"
                                     dataKey="id" editMode="row" [tableStyle]="{'min-width': '50rem'}">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width:20%">Obras</th>
                                        <th style="width:5%">Cantidad</th>
                                        <th style="width:5%">U</th>
                                        <th style="width:20%">Ubicación (Calle)</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-obras let-editing="editing" let-ri="rowIndex">
                                    <tr [pEditableRow]="obras">
                                        <td>
                                            {{ obras.obra }}
                                        </td>
                                        <td [pEditableColumn]="obras.cantidad" pEditableColumnField="cantidad">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="number" [min]="0" [max]="100"
                                                           [(ngModel)]="obras.cantidad"
                                                           (input)="onInputCantidad(obras,$event)"
                                                           (keydown)="isNumericValid($event)"/>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ obras.cantidad }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>
                                            {{ obras.unidad }}
                                        </td>
                                        <td [pEditableColumn]="obras.ubicacion" pEditableColumnField="ubicacion">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <textarea rows="2" cols="60" pInputTextarea
                                                              [(ngModel)]="obras.ubicacion"></textarea>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ obras.ubicacion }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <p-divider/>
                        <div>
                            <p-table styleClass="p-datatable-gridlines" [value]="recepcionProyectoDetalle"
                                     dataKey="id" editMode="row" [tableStyle]="{'min-width': '50rem'}">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width:5%">Block</th>
                                        <th style="width:15%">Poligono</th>
                                        <th style="width:20%">Descripción lotes</th>
                                        <th style="width:5%">Cantidad</th>
                                        <th style="width:20%">Via de acceso</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-detalleObras let-editing="editing" let-ri="rowIndex">
                                    <tr [pEditableRow]="detalleObras">
                                        <td [pEditableColumn]="detalleObras.block " pEditableColumnField="block">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="text" [(ngModel)]="detalleObras.block"/>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ detalleObras.block }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td [pEditableColumn]="detalleObras.poligono " pEditableColumnField="poligono">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="text" [(ngModel)]="detalleObras.poligono"/>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ detalleObras.poligono }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>
                                            {{ detalleObras.descripcionEntidad }}
                                        </td>
                                        <td>
                                            {{ detalleObras.cantidad }}
                                        </td>
                                        <td [pEditableColumn]="detalleObras.viaAcceso" pEditableColumnField="viaAcceso">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <textarea rows="2" cols="60" pInputTextarea
                                                              [(ngModel)]="detalleObras.viaAcceso"></textarea>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ detalleObras.viaAcceso }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <div style="display: flex; gap: 1rem; margin-top: 2rem;">
                                <div class="field">
                                <span class="p-float-label">
                                    <input [(ngModel)]="totales" id="totales" type="number" [min]="0" placeholder="%"
                                           (keydown)="isNumericValid($event)" required pInputText
                                           [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && (totales == 0 || totales == null)}"/>
                                    <label for="totales">Totales <small style="color:red"><b>*</b></small></label>
                                </span>
                                </div>

                                <div class="field">
                                <span class="p-float-label">
                                    <input [(ngModel)]="U" id="u" type="number" [min]="0" placeholder="%"
                                           (keydown)="isNumericValid($event)" required pInputText
                                           [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && (U == 0 || U == null)}"/>
                                    <label for="u">U <small style="color:red"><b>*</b></small></label>
                                </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #recepcionElse>
                        <div>
                            <p-table styleClass="p-datatable-gridlines" [value]="obrasEdificacion" dataKey="id"
                                     editMode="row" [tableStyle]="{'min-width': '50rem'}">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width:20%">Obras</th>
                                        <th style="width:20%">Cantidad</th>
                                        <th style="width:20%">U</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-obras let-editing="editing" let-ri="rowIndex">
                                    <tr [pEditableRow]="obras">
                                        <td>
                                            {{ obras.obra }}
                                        </td>
                                        <td [pEditableColumn]="obras.cantidad" pEditableColumnField="cantidad">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="number" [min]="0" [max]="100"
                                                           [(ngModel)]="obras.cantidad"
                                                           (input)="onInputCantidad(obras,$event)"
                                                           (keydown)="isNumericValid($event)"/>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ obras.cantidad }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>
                                            {{ obras.unidad }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <p-divider/>
                        <div>
                            <p-table styleClass="p-datatable-gridlines" [value]="recepcionProyectoDetalle"
                                     dataKey="id" editMode="row" [tableStyle]="{'min-width': '50rem'}">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width:5%">Block</th>
                                        <th style="width:15%">Poligono</th>
                                        <th style="width:20%">Descripción viviendas o edificios</th>
                                        <th style="width:5%">Cantidad</th>
                                        <th style="width:20%">Via de acceso</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-detalleObras let-editing="editing" let-ri="rowIndex">
                                    <tr [pEditableRow]="detalleObras">
                                        <td [pEditableColumn]="detalleObras.block " pEditableColumnField="block">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="text" [(ngModel)]="detalleObras.block"/>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ detalleObras.block }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td [pEditableColumn]="detalleObras.poligono " pEditableColumnField="poligono">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="text" [(ngModel)]="detalleObras.poligono"/>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ detalleObras.poligono }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>
                                            {{ detalleObras.descripcionEntidad }}
                                        </td>
                                        <td>
                                            {{ detalleObras.cantidad }}
                                        </td>
                                        <td [pEditableColumn]="detalleObras.viaAcceso" pEditableColumnField="viaAcceso">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <textarea rows="2" cols="60" pInputTextarea
                                                              [(ngModel)]="detalleObras.viaAcceso"></textarea>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ detalleObras.viaAcceso }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <div style="display: flex; gap: 1rem; margin-top: 2rem;">
                                <div class="field">
                                <span class="p-float-label">
                                    <input [(ngModel)]="totales" id="totalesC" type="text"
                                           (keydown)="isNumericValid($event)" required pInputText
                                           [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && (totales == 0 || totales == null)}"/>
                                    <label for="totalesC">Totales <small style="color:red"><b>*</b></small></label>
                                </span>
                                </div>

                                <div class="field">
                                <span class="p-float-label">
                                    <input [(ngModel)]="U" id="UC" type="text" (keydown)="isNumericValid($event)"
                                           required pInputText
                                           [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && (U == 0 || U == null)}"/>
                                    <label for="UC">U <small style="color:red"><b>*</b></small></label>
                                </span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-accordionTab>


                <p-divider/>
                <p-accordionTab  header="Documentos y formularios" class="line-height-3 m-0">
                    <solicitud-requisitos [requisitos]="tramiteService.requisitosFormularios()"
                                          [idProyecto]="this.idProyecto"
                                          [idSolicitud]="this.selected!.idSolicitud?.toString()!"
                                          [idTramite]="this.idTramite"
                                          [datosCargados]="tramiteService.datosCargados"
                                          (onEventEmitterSelected)="onReceiveTramite($event)"
                    ></solicitud-requisitos>
                </p-accordionTab>
            </p-accordion>
        </div>
        <p-divider/>
        <p-panel [collapsed]="true" [header]="'Tramite Previos'"
                 [toggleable]="true" *ngIf=" !condicion;">
            <ng-container *ngIf="!condicion;">
                <app-tramites-previos *ngIf="!condicion" [pivoteTramitesPrevios]="2"></app-tramites-previos>
            </ng-container>
        </p-panel>
    </div>

    <div class="p-fluid p-formgrid grid mt-2">
        <div class="field col-12 md:col-9">
            <ul class="list-none m-0 w-full">
                <li class="flex justify-content-between surface-border py-3">
                    <span class="text-900 text-4xl font-medium">Total a cancelar por trámite: $ <b>{{ tarifa }}</b>
                    </span>
                </li>
            </ul>
        </div>
        <div class="field col-12 md:col-3">
            <div class="flex justify-content-end gap-2">
                <p-button class="ml-3" icon="pi pi-calculator" (onClick)="onChangeCalcularTarifa()"
                        styleClass="p-button-icon p-button-info p-button-lg p-button-rounded w-full h-full"
                        pTooltip="Calcular tarifa" tooltipPosition="top"></p-button>
                <p-button (onClick)="completarTramite()" label="Proceder a pagar"
                        icon="pi pi pi-cart-plus"
                        iconPos="right"
                        [rounded]="true"
                        styleClass="p-button-icon p-button-info text-xl h-full"
                        [disabled]="validacionBotonCompletarTramite()"></p-button>
            </div>
        </div>

    </div>
    <div class="p-fluid grid" *ngIf="tramiteService.textTarifa!=''">
        <div class="col-12 align-self-center">
            <small class="text-gray-600">*{{ tramiteService.textTarifa }}</small>
        </div>
    </div>
</p-card>
